










































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import User from "../../../store/entities/user";
@Component({
    components: {}
})
export default class CreateAdmin extends AbpBase {
@Prop({ type: Boolean, default: false }) value: boolean;

    user: User = new User();
    spinShow:boolean = false;
    save() {
        this.user.surname = "no";
        this.user.emailAddress = this.user.userName + "@golfreservations.club";
        this.user.roleNames = ['Admin'];
        (this.$refs.userForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.spinShow = true;
                await this.$store.dispatch({
                    type: "user/create",
                    data: this.user
                });
                (this.$refs.userForm as any).resetFields();
                this.$Message.success(this.L("AddSuccessMessage",undefined,this.L('Administrator')));
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    mounted(){
    }
    cancel() {
        (this.$refs.userForm as any).resetFields();
    }
    validatePassCheck = (rule: any, value: any, callback: any) => {
        if (!value) {
            callback(new Error(this.L("ConfirmPasswordMsg")));
        } else if (value !== this.user.password) {
            callback(new Error(this.L("ConfirmPasswordNotMatch")));
        } else {
            callback();
        }
    };
    visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }
        }
    userRule = {
        userName: [
            {
                required: true,
                message: this.L(
                    "FieldIsRequired",
                    undefined,
                    this.L("UserName")
                ),
                trigger: "blur"
            },
            {
                pattern: /^[A-Za-z0-9_@.]{5,32}$/,
                message: this.L("IncorrectFormatUserName"),
                trigger: "blur"
            }
        ],
        name: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("AdminName")),
                trigger: "blur"
            }
        ],
        phoneNumber: [
            {
                required: true,
                message: this.L(
                    "FieldIsRequired",
                    undefined,
                    this.L("MobileNumber")
                ),
                trigger: "blur"
            },
            {
                pattern: /^1[3456789]\d{9}$/,
                message: this.L("IncorrectFormat",undefined,this.L("MobileNumber")),
                trigger: "blur"
            }
        ],
        password: [
            {
                required: true,
                message: this.L(
                    "FieldIsRequired",
                    undefined,
                    this.L("Password")
                ),
                trigger: "blur"
            }
        ],
        confirmPassword: { validator: this.validatePassCheck, trigger: "blur" }
    };
}
